// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"580":"dd497695","848":"2e748fdc"}[chunkId] + ".chunk.css";
};